import { useEffect, useState } from "react";
import { toast } from "sonner";
import { ShieldCheck } from "lucide-react";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { api, formatApiError } from "@/lib/api";

export function ReauthDialog() {
  const [resolver, setResolver] = useState(null);
  const [pw, setPw] = useState("");
  const [busy, setBusy] = useState(false);
  useEffect(() => {
    const onReauth = (e) => setResolver(() => e.detail);
    window.addEventListener("pf:reauth", onReauth);
    return () => window.removeEventListener("pf:reauth", onReauth);
  }, []);
  const close = (ok) => { resolver?.(ok); setResolver(null); setPw(""); };
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try { await api.post("/auth/reauth/password", { password: pw }); toast.success("Confirmed for 10 minutes"); close(true); }
    catch (err) { toast.error(formatApiError(err)); } finally { setBusy(false); }
  };
  const google = () => {
    sessionStorage.setItem("pf_reauth", window.location.pathname + window.location.search);
    close(false);
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(window.location.origin + window.location.pathname)}`;
  };
  return (
    <Dialog open={!!resolver} onOpenChange={(o) => !o && close(false)}>
      <DialogContent className="border-amber-900/40 bg-[#121620]" data-testid="reauth-dialog">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2 font-heading text-amber-100"><ShieldCheck className="h-5 w-5" />Confirm it's you</DialogTitle>
          <DialogDescription>Sensitive credential changes need a fresh confirmation. It stays valid for 10 minutes.</DialogDescription>
        </DialogHeader>
        <form onSubmit={submit} className="grid gap-3">
          <label htmlFor="reauth-password" className="text-xs text-slate-400">Password</label>
          <input id="reauth-password" type="password" autoFocus className="field" value={pw} onChange={(e) => setPw(e.target.value)} data-testid="reauth-password-input" />
          <button className="btn-gold" disabled={!pw || busy} data-testid="reauth-submit-button">Confirm</button>
          <button type="button" className="btn-outline" onClick={google} data-testid="reauth-google-button">I sign in with Google: re-confirm with Google</button>
        </form>
      </DialogContent>
    </Dialog>
  );
}
